module.exports = __webpack_public_path__ + "img/no_get.8cfd0af.png";